// Regios DOPP applies its own automatic-discount badge/price per price container
// (fired via the "regios-dopp:price-update" event). When it actually applies a
// discount, hide the theme's own compare-at-price "% OFF" badge on that same
// container so we don't show two conflicting discount indicators.
window.addEventListener('regios-dopp:price-update', function (e) {
  var detail = (e && e.detail) || {};
  var container = detail.priceContainer;
  if (!detail.discountWasApplied || !container) return;

  var pdpBadge = container.querySelector('.price-badge');
  if (pdpBadge) pdpBadge.style.display = 'none';

  container.querySelectorAll('.product-single__price--discount').forEach(function (el) {
    el.style.display = 'none';
  });

  var card = container.closest('[data-product-card]');
  var ticker = card && card.querySelector('.product__ticker--discount');
  if (ticker) ticker.style.display = 'none';
});